
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { updateAllUsersToFreePlan } from "@/utils/migrations/updateAllUsersToFreePlan";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const MigrationRunner = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState<{
    success?: boolean;
    message?: string;
    count?: number;
  }>({});

  const runMigration = async () => {
    try {
      setIsRunning(true);
      setResult({});
      
      // Confirm before running
      if (!window.confirm("Are you sure you want to update all users to Free (Forever) plan?")) {
        setIsRunning(false);
        return;
      }
      
      const result = await updateAllUsersToFreePlan();
      setResult(result);
      
      if (result.success) {
        toast.success("Migration completed", {
          description: result.message
        });
      } else {
        toast.error("Migration failed", {
          description: result.message
        });
      }
    } catch (error) {
      console.error("Error running migration:", error);
      setResult({
        success: false,
        message: `Unexpected error: ${error instanceof Error ? error.message : String(error)}`
      });
      
      toast.error("Migration failed", {
        description: "An unexpected error occurred"
      });
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-medium mb-2">Subscription Plan Migration</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Update all users' subscription status to "Free (Forever)" to ensure consistency with plan names.
      </p>
      
      <Button 
        onClick={runMigration}
        disabled={isRunning}
        variant="outline"
      >
        {isRunning ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Running Migration...
          </>
        ) : (
          'Run Migration'
        )}
      </Button>
      
      {result.message && (
        <div className={`mt-4 p-3 rounded text-sm ${result.success ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
          <p><strong>{result.success ? 'Success' : 'Error'}:</strong> {result.message}</p>
          {result.count !== undefined && <p>Updated {result.count} user(s)</p>}
        </div>
      )}
    </div>
  );
};
